import { useState } from "react";
import { useSignIn } from "@clerk/clerk-react";
import { useToast } from "@/hooks/use-toast";
import { SignInCard } from "@/components/ui/sign-in-card";
import shomriLogo from "@/assets/shomri-logo-new.png";

export const AuthenticationPage = () => {
  const { signIn, setActive } = useSignIn();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleSignIn = async (email: string, password: string) => {
    if (!email || !password) {
      toast({
        title: "Error",
        description: "Please enter both email and password",
        variant: "destructive",
      });
      return;
    }

    if (!signIn) return;

    setIsLoading(true);
    try {
      const result = await signIn.create({
        identifier: email,
        password,
      });

      if (result.status === "complete") {
        await setActive({ session: result.createdSessionId });
        toast({
          title: "Success",
          description: "Signed in successfully",
        });
      }
    } catch (error: any) {
      toast({
        title: "Error",
        description: error?.errors?.[0]?.message || "Failed to sign in. Please check your credentials.",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SignInCard
      onSubmit={handleSignIn}
      isLoading={isLoading}
      logo={shomriLogo}
      title="Welcome Back"
      subtitle="Sign in to continue to Shomri"
    />
  );
};
